var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',{staticClass:"py-0",attrs:{"fluid":""}},[_c('VRow',{attrs:{"dense":""}},[_c('SearchBar',{staticClass:"mb-6",attrs:{"store-class":_vm.storeClass,"placeholder":'',"initial-term":_vm.initialTerm},on:{"selected":_vm.selected},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("placeholder")]},proxy:true}],null,true)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }